//
// Utility Plugin for setting the configuration
//
import { pluginFactory } from './utils/plugins';
var BVConfigPlugin =
/*#__PURE__*/
pluginFactory();
export default BVConfigPlugin;